<div style="margin-top: 2.563rem">
  <span style="font-size: 1.5rem; margin-left: 8%;">Hello {{firstName}}, what would you like to do?</span>
</div>

<!-- Show message for users with no access while checking approver status -->
<div *ngIf="!hasAnyAccess() && checkingApproverStatus" style="text-align: center; margin-top: 3rem;">
  <span style="font-size: 1.2rem;">Checking access permissions...</span>
</div>

<!-- Show access denied only if no access and not an approver -->
<div *ngIf="!hasAnyAccess() && !checkingApproverStatus" style="text-align: center; margin-top: 3rem;">
  <span style="font-size: 1.2rem; color: red;">You do not have access to create any forms.</span>
</div>

<!-- Limited view for Gas-only users -->
<div *ngIf="hasOnlyGasAccess()" class="grid-container">
  <div class="grid-item" (click)="openGasProjectDialog()">
    <span style="font-size: 1.25rem; display: table; margin: auto; margin-top: 3.5rem;">Set Up Gas Projects</span>
  </div>
</div>


<!-- Approver-only dashboard buttons removed: all users see the same dashboard UI. -->

<!-- Full dashboard for users with other access -->
<div *ngIf="!hasOnlyGasAccess() && hasAnyAccess() && !isApproverOnly" class="grid-container">
  <div *ngIf="hasGasAccess() && environment.showGasForm" class="grid-item"
     (click)="openGasProjectDialog()">
    <span style="font-size: 1.25rem; display: table; margin: auto; margin-top: 3.5rem;">Set Up Gas Projects</span>
  </div>
  <div *ngIf="hasETSAccess() && environment.showETSForm" class="grid-item"
    (click)="openITProjectSetup()">
    <span style="padding: 0 2rem; font-size: 1.25rem; display: table; margin: auto; margin-top: 0.7rem; text-align: center;">Create Accounting Request Form</span>
    <span style="padding: 0 1rem; font-size: 1rem; display: table; margin: auto; margin-top: 0.7rem; text-align: center;">(Security, Security Compliance, Technology & Innovation)</span>
  </div>
  <div *ngIf="hasGenerationAccess() && environment.showGenerationForm" class="grid-item"
    (click)="openRREProjectSetup()">
    <span style="font-size: 1.25rem; display: table; margin: auto; margin-top: 3.5rem;">Set Up Generation Project</span>
  </div>
  <div *ngIf="hasRealEstateAccess() && environment.showRealEstateForm" class="grid-item"
    (click)="openRealEstateProjectSetup()">
    <span style="padding: 0 2rem; font-size: 1.25rem; display: table; margin: auto; margin-top: 2.35rem; text-align: center;">Submit a Real Estate Funding Request</span>
    <span *ngIf="hasApproverAccess()" style="font-size: 0.9rem; color: #007cba; display: table; margin: auto; margin-top: 0.5rem; text-align: center;"></span>
  </div>
</div>